import { AuthService } from "shared-service/services/auth/auth.service";
import { of, switchMap } from "rxjs";

import { inject } from "@angular/core";
import { CanActivateChildFn, CanActivateFn, Router } from "@angular/router";

/** Đăng xuất KHÔNG được phụ thuộc vào việc phiên còn sống hay không. */
const isSignOutUrl = (url: string): boolean => {
    const path = url.split(/[?#]/, 1)[0].replace(/\/+$/, "") || "/";
    return path === "/sign-out" || path === "/profile/sign-out";
};

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);

    // Phiên BFF hết hạn trước khi người dùng kịp bấm Đăng xuất thì guard sẽ nắn sang /sign-in, màn
    // AuthSignOutComponent không bao giờ chạy — nghĩa là end-session Keycloak KHÔNG được gọi và cookie
    // SSO của tài khoản cũ sống tiếp. Người dùng thấy trang đăng nhập, tưởng đã ra ngoài, rồi lần đăng
    // nhập sau bị Keycloak đưa thẳng về tài khoản cũ. Cho đi qua để việc dọn phiên luôn chạy trọn vẹn.
    if (isSignOutUrl(state.url)) {
        return of(true);
    }

    // Check the authentication status
    return inject(AuthService)
        .check()
        .pipe(
            switchMap((authenticated) => {
                // If the user is not authenticated...
                if (!authenticated) {
                    // Redirect to the sign-in page with a redirectUrl param
                    const urlTree = router.createUrlTree(
                        ["/sign-in"],
                        state.url === "/sign-out"
                            ? undefined
                            : { queryParams: { redirectURL: state.url } },
                    );

                    return of(urlTree);
                }

                // Allow the access
                return of(true);
            }),
        );
};
